import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import * as R from 'ramda';

import countryTranslation from 'i18n-iso-countries';
import french from 'i18n-iso-countries/langs/fr.json';
import { toast } from 'react-toastify';
import { ToasterConfigurations } from '../../../../constants/toasterText/configurations';
import { DateWithModal } from '../../../../_common/dateWithModal';
import { Header } from '../_common/header';
import * as loadings from '../../../../constants/loadings/user';
import { getAddressesByUserId, updateAddressById, updateUser } from '../../../../actions/facilita-api';
import { PostalCityInput } from "../../../../_common/postalCityInput";


export const SettingsProfil = ({ user, isLoading, roles }) => {
    const dispatch = useDispatch();
    countryTranslation.registerLocale(french);

    const [userInfo, setUserInfo] = useState(user);

    const gender = { male: 'Male', female: 'Female' };

    useEffect(() => {
        dispatch(getAddressesByUserId(user.id));
    }, [user]);

    if (R.isNil(userInfo.addresses)) {
        return '';

    }

    return (
			<article className="view-calc pt-sm mb-auto">
				<Header roles={roles} />
				<div className="auto-view py-3 pb-lg-0">
					<div className="container-fluid">
						<form className="block mt-4" noValidate>
							<h3 className="h3 font-weight-bold mb-4">Mes données</h3>
							<section className="block pb-3">
								<h4 className="h4 text-uppercase text-secondary font-weight-bolder my-2 mb-0">ETAT CIVIL</h4>
								<div className="form-inline mb-3">
									<div className="custom-control custom-radio custom-control-inline mr-6">
										<input required type="radio" id="Madame" name="SexMadameMonsieur" className="custom-control-input" checked={userInfo.gender === gender.female} onChange={(e) => setUserInfo({ ...userInfo, gender: gender.female })} />
										<label className="custom-control-label" htmlFor="Madame">
											Madame
										</label>
									</div>
									<div className="custom-control custom-radio custom-control-inline">
										<input type="radio" id="Monsieur" name="SexMadameMonsieur" className="custom-control-input" checked={userInfo.gender === gender.male} onChange={(e) => setUserInfo({ ...userInfo, gender: gender.male })} />
										<label className="custom-control-label" htmlFor="Monsieur">
											Monsieur
										</label>
									</div>
								</div>
								<div className="form-row">
									<div className="form-group col col-xl-4">
										<label className="h6 font-weight-bolder my-auto" htmlFor="Prenom">
											Prénom *
										</label>
										<input required type="text" className="form-control" id="Prenom" value={userInfo.firstName} onChange={(e) => setUserInfo({ ...userInfo, firstName: e.target.value })} />
									</div>
									<div className="form-group col col-xl-4">
										<label className="h6 font-weight-bolder my-auto" htmlFor="Nom">
											Nom *
										</label>
										<input required type="text" className="form-control" id="Nom" value={userInfo.lastName} onChange={(e) => setUserInfo({ ...userInfo, lastName: e.target.value })} />
									</div>
									<div className="form-group col col-xl-4">
										<label className="h6 font-weight-bolder my-auto" htmlFor="naissance">
											Date de naissance *
										</label>
										<DateWithModal isRequired={true} selectedDate={userInfo.birthDate} setSelectedDate={(d) => setUserInfo({ ...userInfo, birthDate: d })} />
									</div>
									{/* Show only if admin or super admin */}
									{/* <div className="form-group col-12 col-md-4">
                                    <label className="h6 font-weight-bolder my-auto" htmlFor="Permissions">Role *</label>
                                    <select className="custom-select" id="Permissions" tabIndex={-98} >
                                        <option value=""></option>
                                    </select>
                                </div> */}
								</div>

								<h4 className="h4 text-uppercase text-secondary font-weight-bolder my-2 mb-0">ADRESSE</h4>
								<div className="form-row">
									<div className="form-group col-12 col-sm col-xl">
										<label className="h6 font-weight-bolder my-auto" htmlFor="addressLine1">
											Adresse
										</label>
										<input
											required
											type="text"
											className="form-control"
											id="addressLine1"
											value={R.isNil(userInfo.addresses) ? "" : userInfo.addresses[0].addressLine1}
											onChange={(e) =>
												setUserInfo({
													...userInfo,
													addresses: userInfo.addresses.map((address, idx) => {
														return idx === 0 ? { ...address, addressLine1: e.target.value } : address;
													}),
												})
											}
										/>
									</div>
								</div>
								<div className="form-row">
									<PostalCityInput
										postalCode={R.isNil(userInfo.addresses) ? "" : userInfo.addresses[0].postalCode}
										city={R.isNil(userInfo.addresses) ? "" : userInfo.addresses[0].city}
										onChange={(updatedAddress) =>
											setUserInfo({
												...userInfo,
												addresses: userInfo.addresses.map((address, idx) => {
													return idx === 0 ? { ...address, postalCode: updatedAddress.postalCode, city: updatedAddress.city } : address;
												})
											})
										}
										hasWrapper={false}
										country={R.isNil(userInfo.addresses) ? "" : userInfo.addresses[0].country}
										customClasses={{ city: "form-group col col-xl-4", postalCode: "form-group col col-xl-4" }}
									/>
									{/* <div className="form-group col col-xl-4">
										<label className="h6 font-weight-bolder my-auto" htmlFor="zipcode">
											Code Postal
										</label>
										<input
											required
											type="text"
											className="form-control"
											id="zipcode"
											value={R.isNil(userInfo.addresses) ? "" : userInfo.addresses[0].postalCode}
											onChange={(e) =>
												setUserInfo({
													...userInfo,
													addresses: userInfo.addresses.map((address, idx) => {
														return idx === 0 ? { ...address, postalCode: e.target.value } : address;
													}),
												})
											}
										/>
									</div>
									<div className="form-group col col-xl-4">
										<label className="h6 font-weight-bolder my-auto" htmlFor="city">
											Ville
										</label>
										<input
											required
											type="text"
											className="form-control"
											id="city"
											value={R.isNil(userInfo.addresses) ? "" : userInfo.addresses[0].city}
											onChange={(e) =>
												setUserInfo({
													...userInfo,
													addresses: userInfo.addresses.map((address, idx) => {
														return idx === 0 ? { ...address, city: e.target.value } : address;
													}),
												})
											}
										/>
									</div> */}
									<div className="form-group col col-xl-4">
										<label className="h6 font-weight-bolder my-auto" htmlFor={"Paysentreprise"}>
											Pays
										</label>
										<select
											className="custom-select"
											id={"Paysentreprise"}
											tabIndex={-98}
											value={R.isNil(userInfo.addresses) ? "" : userInfo.addresses[0].country}
											onChange={(e) =>
												setUserInfo({
													...userInfo,
													addresses: userInfo.addresses.map((address, idx) => {
														return idx === 0 ? { ...address, country: e.target.value } : address;
													}),
												})
											}>
											{Object.values(countryTranslation.getNames("fr", { select: "official" }))
												.sort()
												.map((countryName) => {
													const countryCode = countryTranslation.getAlpha2Code(countryName, "fr");
													return (
														<option key={countryCode} value={countryCode}>
															{countryName}
														</option>
													);
												})}
										</select>
									</div>
								</div>
							</section>
						</form>
					</div>
					<div className="container-fluid">
						<footer className="flex-md-row align-items-center mt-auto mb-sm w-100">
							{isLoading.includes(loadings.UPDATE_USER) || isLoading.includes(loadings.UPDATING_USER_ADDRESS) ? (
								<button type="button" className="btn btn-info loading-btn show">
									Sauvegarder<div className="loading loading-spinner spinner-border spinner-border-sm ml-2 mr-n1"></div>
								</button>
							) : (
								<button
									className="btn btn-info"
									onClick={(e) => {
										e.preventDefault();
										const { addresses, ...userWithoutAddress } = userInfo;
										dispatch(updateUser({ ...userWithoutAddress, professionalSituation: userWithoutAddress.professionalSituation.toString() }))
											.then(() => dispatch(updateAddressById(userWithoutAddress.id, addresses[0])))
											.then(() => toast.success("Les données ont été mises à jour.", ToasterConfigurations))
											.catch(() => toast.error("Une erreur est survenue.", ToasterConfigurations));
									}}>
									Sauvegarder
								</button>
							)}

							<h6 className="my-3 my-md-0 mr-auto order-lg-first fs-3 o-60">* champs obligatoires</h6>
						</footer>
					</div>
				</div>
			</article>
		);
};